import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { LogperiodicjobsData } from '../../providers/logperiodicjobs-data';
import moment from 'moment';

/**
 * Generated class for the PbcatrulesComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'automatedjobs',
  templateUrl: 'automatedjobs.html'
})
export class AutomatedjobsComponent {

  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public userData: UserData
    , public lpj: LogperiodicjobsData
  ) 
  {
    //console.log(lpj.data);
  }

  
}



// WEBPACK FOOTER //
// ./src/components/automatedjobs/automatedjobs.ts